// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a15a5c4d","455":"f885a43f"}[chunkId] + ".chunk.js";
};